import { gql } from '@apollo/client'

import HELP_CENTER_ARTICLES_FRAGMENT from 'src/components/sections/HelpCenterArticles/fragments'

export const MEMBERSHIP_PRODUCT = gql`
  query MembershipProduct_BuyInfo_MembershipProduct {
    membershipProduct(id: "2") {
      id
      prices(interval: YEAR) {
        id
        value
        currencyCode
        recurring {
          interval
          intervalCount
        }
      }
    }
  }
`

export const MEMBERSHIP_USER_DISCOUNT = gql`
  query MembershipProduct_BuyInfo_MembershipProductPriceDiscount {
    membershipProductPriceDiscount(membershipProductId: "2", membershipProductPriceInterval: YEAR) {
      product {
        id
      }
      priceDiscounted {
        value
        currencyCode
      }
      discount {
        ... on MembershipDiscountCoupon {
          duration
          durationInMonths
        }
        ... on MembershipDiscountPromoCode {
          coupon {
            duration
            durationInMonths
          }
        }
      }
    }
  }
`

export default gql`
  query MembershipProduct {
    faqs: helpCenterArticles(topicSlug: "memberships") {
      ...HelpCenterArticlesComponent
    }
  }

  ${HELP_CENTER_ARTICLES_FRAGMENT}
`
